import { TextField, TextFieldProps } from "@mui/material";
import React from "react";
import {
  FieldValues,
  useController,
  UseControllerProps,
} from "react-hook-form";

export type TextInputProps<T extends FieldValues> = UseControllerProps<T> &
  Omit<TextFieldProps, "value" | "defaultValue">;

export function TextInput<T extends FieldValues>({
  name,
  control,
  defaultValue,
  rules,
  shouldUnregister,
  ...props
}: TextInputProps<T>) {
  const {
    field: { value, onChange: fieldOnChange, ...field },
    fieldState,
  } = useController<T>({
    name,
    control,
    defaultValue,
    rules,
    shouldUnregister,
  });

  return (
    <TextField
      value={value}
      onChange={(e) => {
        fieldOnChange(e);
      }}
      error={fieldState.invalid}
      helperText={fieldState.error?.message}
      {...field}
      {...props}
    />
  );
}

export default TextInput;
